import { InjectionToken, Signal } from '@angular/core';

export const FEATURE_S_HEADER_PERFIL_LABEL = new InjectionToken<
  Signal<string | null>
>('FEATURE_S_HEADER_PERFIL_LABEL');
